/* eslint-disable no-use-before-define */
import { graphql, useStaticQuery } from 'gatsby';
import { useContext } from 'react';
import localeContext from './localeContext';

function useExtractTranslations() {
  const { locale } = useContext(localeContext);
  const {
    rawData: { edges },
  } = useStaticQuery(query);

  const [{ translations: currentTranslations }] = edges
    .map(({ node: { name, translations } }) => ({
      name,
      translations,
    }))
    .filter(({ name }) => name === locale.lang);

  return currentTranslations;
}

export default useExtractTranslations;

const query = graphql`
  query useExtractTranslations {
    rawData: allFile(filter: { sourceInstanceName: { eq: "translations" } }) {
      edges {
        node {
          name
          translations: childTranslationsJson {
            not_found_title
            index_meta_title
            index_meta_description
            index_title
            home_claim_first_paragraph
            home_claim_second_paragraph
            home_claim_second_paragraph
            home_highlight_components_title
            home_highlight_components_text
            home_highlight_performance_title
            home_highlight_performance_text
            home_highlight_3d_title
            home_highlight_3d_text
            home_highlight_craft_title
            home_highlight_craft_text
            home_highlight_tested_title
            home_highlight_tested_text
          }
        }
      }
    }
  }
`;
